import { render, staticRenderFns } from "./nav-bar.vue?vue&type=template&id=09563c40"
import script from "./nav-bar.ts?vue&type=script&lang=ts&external"
export * from "./nav-bar.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports